module.exports = __webpack_public_path__ + "img/offer-1.94430c44.png";